import {breakpointUp} from "./utils/breakpoints";
import { waitForLocoScrollUpdate } from './locomotive-scroll'

function setupPostActions(locoScroll) {

  const target = document.querySelector('#page-content')
  let postsGrid = '#posts-grid'
  let jsLocoScroll = '.js-loco-scroll'

  $(postsGrid).attr('data-post-loading', 0)

  $('body').on('click', jsLocoScroll, function (e){
    e.preventDefault()

    $(postsGrid).attr('data-post-loading', 1)
    waitForLocoScrollUpdate(postsGrid)

    if(breakpointUp('lg')) {
      locoScroll.scrollTo(target, { offset: -100})
    } else {
      $("html, body").animate({scrollTop: 200}, 400);
    }

  })

}

export { setupPostActions }
